<template>
  <div v-if="$breakpoint.mdAndUp">
    <div v-if="isLoading" class="flex">
      <UtilPlaceholder class="h-4 w-2/12 sm:w-1/12 mr-2" />
      <UtilPlaceholder class="h-4 w-3/12 sm:w-2/12 mr-2" />
      <UtilPlaceholder class="h-4 w-7/12 sm:w-3/12" />
    </div>

    <nav v-else-if="crumbs.length" aria-label="Breadcrumb" class="breadcrumbs mx-0 ">
      <ul class="truncate">
        <li
          v-for="crumb in crumbs"
          :key="crumb.label"
          class="pl-2 inline"
          :class="{
            active: crumb.current,
            'with-link': !crumb.disableInteraction,
            'cursor-not-allowed': crumb.disableInteraction
          }"
        >
          <FontAwesomeIcon :icon="faChevronRight" class="crumb-icon mr-2" />

          <RouterLink
            v-if="crumb.to && !crumb.disableInteraction && !crumb.current"
            :to="crumb.to"
            class="crumb-link"
          >
            <span>{{ crumb.label }}</span>
          </RouterLink>

          <span v-else>{{ crumb.label }}</span>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons'
import UtilPlaceholder from '@/components/utils/placeholders/UtilPlaceholder'

export default {
  name: 'WidgetBreadcrumbs',
  components: {
    UtilPlaceholder
  },
  props: {
    crumbs: {
      type: Array,
      default: () => []
    },
    isLoading: Boolean
  },
  data() {
    return {
      faChevronRight
    }
  }
}
</script>

<style lang="scss" scoped>
$breadcrumbPadding: 0.8em;

.breadcrumbs ul {
  list-style: none;
  // opacity: 0.7;

  &:hover {
    opacity: 1;
  }
}

.breadcrumbs li {
  display: inline-block;
  @apply text-gray;

  &:first-child {
    padding-left: 0;
  }
}

.breadcrumbs li.with-link:hover {
  @apply underline;
}

.breadcrumbs li.active {
  @apply text-gray;

  &:hover {
    @apply no-underline;
  }
}

.crumb-icon {
  font-size: 70%;
  @apply text-gray-darker;
}

.crumb-link {
  @apply text-gray-darker;
}

.breadcrumbs li:first-child .crumb-icon {
  display: none;
}
</style>
